import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useTranslation } from 'react-i18next'
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md'
import api from '../services/api'

const Footer = () => {
    const { isAuthenticated } = useAuth();
    const { t, i18n } = useTranslation();
    const [companyInfo, setCompanyInfo] = useState({
        email: 'destek@nordexcrypto.com',
        phoneNumber: '+44 7378 777865',
        addressTr: 'Bärengasse 16, 8001 Zürich, İsviçre',
        addressEn: 'Bärengasse 16, 8001 Zürich, Switzerland',
        googleMapsLink: 'https://www.google.com/maps/search/?api=1&query=B%C3%A4rengasse+16%2C+8001+Z%C3%BCrich%2C+Switzerland'
    });
    const ukOffice = {
        addressTr: '73 Clarendon Rd Watford WD17 1TX, Birleşik Krallık',
        addressEn: '73 Clarendon Rd Watford WD17 1TX, United Kingdom',
        googleMapsLink: 'https://www.google.com/maps/search/?api=1&query=73+Clarendon+Rd+Watford+WD17+1TX%2C+United+Kingdom'
    };
    const socialMedia = [
        {
            img: "https://www.coinex.com/assets/img/common/footer/day/icon-email.svg?t=0724",
            link: "https://google.com.tr"
        },
        {
            img: "https://www.coinex.com/assets/img/common/footer/day/icon-telegram.svg?t=0724",
            link: "https://google.com.tr"
        },
        {
            img: "https://www.coinex.com/assets/img/common/footer/day/icon-twitter.svg?t=0724",
            link: "https://google.com.tr"
        },
        {
            img: "https://www.coinex.com/assets/img/common/footer/day/icon-medium.svg?t=0724",
            link: "https://google.com.tr"
        },
        {
            img: "https://www.coinex.com/assets/img/common/footer/day/icon-instagram.svg?t=0724",
            link: "https://google.com.tr"
        },
    ]

    // Fetch company info
    useEffect(() => {
        const fetchCompanyInfo = async () => {
            try {
                const res = await api.getCompanyInfo();
                const data = res?.data?.data;
                if (data) {
                    setCompanyInfo({
                        email: data.email || 'destek@nordexcrypto.com',
                        phoneNumber: data.phoneNumber || '+44 7378 777865',
                        addressTr: data.addressTr || 'Bärengasse 16, 8001 Zürich, İsviçre',
                        addressEn: data.addressEn || 'Bärengasse 16, 8001 Zürich, Switzerland',
                        googleMapsLink: data.googleMapsLink || 'https://www.google.com/maps/search/?api=1&query=B%C3%A4rengasse+16%2C+8001+Z%C3%BCrich%2C+Switzerland'
                    });
                }
            } catch (e) {
                console.error('Error fetching company info:', e);
            }
        };
        fetchCompanyInfo();
    }, []);

    // Dil bazlı adres seçimi
    const isTr = i18n.language?.startsWith('tr');
    const currentAddress = isTr ? companyInfo.addressTr : companyInfo.addressEn;
    const ukAddress = isTr ? ukOffice.addressTr : ukOffice.addressEn;

    return (
        <>
            <div className='footer-content'>
                <div className="container">
                    <div className="row">
                        <div className={`${isAuthenticated ? 'col-lg-2' : 'col-lg-5'}`}>
                            <div className='d-flex flex-column justify-content-between h-100'>
                                <div>
                                    <img src="/assets/images/nordex-logo.png" alt="nordex-logo" width="250px" />
                                    <div className='mt-lg-4 footer-tagline' style={{ fontSize: 17, fontWeight: 400, marginLeft: 43 }}>{t('footer.tagline')}</div>
                                </div>
                                {/* <div className='social-media-links'>
                                    {
                                        socialMedia.map((item, index) => (
                                            <a href={item.link} target='_blank' className="social-media-item me-2" key={index}>
                                                <img src={item.img} alt="" />
                                            </a>
                                        ))
                                    }
                                </div> */}
                            </div>
                        </div>
                        {isAuthenticated && (
                            <>
                                <div className="col-lg-2">
                                    <h5 className='mb-lg-4'>{t('footer.accountOperations')}</h5>
                                    <ul className='list-unstyled m-0 p-0'>
                                        <li><Link to="/news">{t('footer.news')}</Link></li>
                                        <li><Link to="/account-summary">{t('footer.accountSummary')}</Link></li>
                                        <li><Link to="/two-factor-auth">{t('footer.twoFactorAuth')}</Link></li>
                                        <li><Link to="/referral-code">{t('footer.referralCode')}</Link></li>
                                        <li><Link to="/change-password">{t('footer.changePassword')}</Link></li>
                                    </ul>
                                </div>
                                <div className="col-lg-2">
                                    <h5 className='mb-lg-4'>{t('footer.coinOperations')}</h5>
                                    <ul className='list-unstyled m-0 p-0'>
                                        <li><Link to="/market">{t('footer.market')}</Link></li>
                                        <li><Link to="/documents">{t('footer.documents')}</Link></li>
                                        <li><Link to="/crypto-withdrawals">{t('footer.cryptoWithdrawals')}</Link></li>
                                        <li><Link to="/bank-withdrawals">{t('footer.bankWithdrawals')}</Link></li>
                                        <li><Link to="/open-positions">{t('footer.openPositions')}</Link></li>
                                        <li><Link to="/closed-positions">{t('footer.closedPositions')}</Link></li>
                                    </ul>
                                </div>
                            </>
                        )}
                        <div className="col-lg-2">
                            <h5 className='mb-lg-4'>{t('footer.buyCrypto')}</h5>
                            <ul className='list-unstyled m-0 p-0'>
                                <li><Link to={isAuthenticated ? "/market" : "/login"}>{t('footer.buyBTC')}</Link></li>
                                <li><Link to={isAuthenticated ? "/market" : "/login"}>{t('footer.buyETH')}</Link></li>
                                <li><Link to={isAuthenticated ? "/market" : "/login"}>{t('footer.buySOL')}</Link></li>
                                <li><Link to={isAuthenticated ? "/market" : "/login"}>{t('footer.buyUSDT')}</Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-2">
                            <h5 className='mb-lg-4'>{t('footer.services')}</h5>
                            <ul className='list-unstyled m-0 p-0'>
                                <li><Link to="/referral-program">{t('footer.referralProgram')}</Link></li>
                                <li><Link to="/investment-options">{t('footer.investmentOptions')}</Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-2">
                            <h5 className='mb-lg-4'>{t('footer.contactUs')}</h5>
                            <ul className='list-unstyled m-0 p-0'>
                                <li>
                                    <a href={`mailto:${companyInfo.email}`} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'inherit', textDecoration: 'none' }}>
                                        <MdEmail size={18} />
                                        <span>{companyInfo.email}</span>
                                    </a>
                                </li>
                                <li>
                                    <a href={`tel:${companyInfo.phoneNumber.replace(/\s/g, '')}`} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'inherit', textDecoration: 'none' }}>
                                        <MdPhone size={18} />
                                        <span>{companyInfo.phoneNumber}</span>
                                    </a>
                                </li>
                                <li>
                                    <a href={companyInfo.googleMapsLink} target='_blank' rel='noreferrer' style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'inherit', textDecoration: 'none' }}>
                                        <MdLocationOn size={18} />
                                        <span>{currentAddress}</span>
                                    </a>
                                </li>
                                <li>
                                    <a href={ukOffice.googleMapsLink} target='_blank' rel='noreferrer' style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'inherit', textDecoration: 'none' }}>
                                        <MdLocationOn size={18} />
                                        <span>{ukAddress}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-copyright text-center">
                <p className='mb-0'>
                    {t('footer.copyright')}
                </p>
            </div>
        </>
    )
}

export default Footer